<script>
import { mapState, mapActions } from 'vuex'

export default {
   data() {
      return {
         form: {
            tahun: new Date(this.$store.state.DashboardOss.tahun, 0, 1),
         },
         isRefreshing: false,
      }
   },
   computed: {
      ...mapState({
         myData: state => state.DashboardOss.stattistik,
         tahun: state => state.DashboardOss.tahun,
      }),
      getThisYear() {
         return this.tahun
      },
      statisticGroups() {
         return [
            {
               title: `NIB - ${this.tahun}`,
               icon: 'FileTextIcon',
               color: 'primary',
               items: [
                  {
                     key: 'nib',
                     title: 'NIB Terbit',
                     description: 'Nomor Induk Berusaha yang telah terbit',
                  },
                  {
                     key: 'nib_tw_1',
                     title: 'Triwulan I',
                     description: 'NIB Terbit pada Triwulan I',
                  },
                  {
                     key: 'nib_tw_2',
                     title: 'Triwulan II',
                     description: 'NIB Terbit pada Triwulan II',
                  },
                  {
                     key: 'nib_tw_3',
                     title: 'Triwulan III',
                     description: 'NIB Terbit pada Triwulan III',
                  },
                  {
                     key: 'nib_tw_4',
                     title: 'Triwulan IV',
                     description: 'NIB Terbit pada Triwulan IV',
                  },
               ],
            },
            {
               title: `Izin  - ${this.tahun}`,
               icon: 'CheckCircleIcon',
               color: 'success',
               items: [
                  {
                     key: 'izin',
                     title: 'Izin Terbit',
                     description: 'Total Izin yang Diterbitkan',
                  },
                  {
                     key: 'izin_terbit_terverifikasi',
                     title: 'Terverifikasi',
                     description: 'Status "Izin Terverifikasi"',
                  },
                  {
                     key: 'izin_menunggu_verifikasi',
                     title: 'Menunggu Verifikasi',
                     description: 'Status "Menunggu verifikasi persyaratan"',
                  },
                  {
                     key: 'izin_belum_melengkapi',
                     title: 'Belum Melengkapi Persyaratan',
                     description: 'Status "Belum melengkapi persyaratan"',
                  },
               ],
            },
            {
               title: `Sertifikat Standar - ${this.tahun}`,
               icon: 'AwardIcon',
               color: 'info',
               items: [
                  {
                     key: 'ss',
                     title: 'Sertifikat Standar Terbit',
                     description: 'Total Sertifikat Standar yang diterbitkan',
                  },
                  {
                     key: 'ss_terbit_otomatis',
                     title: 'Terbit Otomatis',
                     description: 'Status "Terbit Otomatis"',
                  },
                  {
                     key: 'ss_terbit_terverifikasi',
                     title: 'Terverifikasi',
                     description: 'Status "Sertifikat Standar Terverifikasi"',
                  },
                  {
                     key: 'ss_menunggu_verifikasi',
                     title: 'Menunggu Verifikasi',
                     description: 'Status "Menunggu Verifikasi persyaratan"',
                  },
                  {
                     key: 'ss_belum_melengkapi',
                     title: 'Belum Melengkapi persyaratan',
                     description: 'Status "Belum melengkapi persyaratan"',
                  },
               ],
            },
            {
               title: 'Status Umum',
               icon: 'ActivityIcon',
               color: 'warning',
               items: [
                  {
                     key: 'syarat_belum',
                     title: 'Belum Memenuhi Persyaratan',
                     description: 'Permohonan yang masih perlu dilengkapi',
                  },
                  {
                     key: 'menunggu_verifikasi',
                     title: 'Menunggu Verifikasi',
                     description: 'Permohonan yang menunggu proses verifikasi',
                  },
               ],
            },
         ]
      },
   },
   watch: {
      'form.tahun': function onYearChanged(newYear) {
         if (newYear) this.refreshStatistics(newYear)
      },
   },
   mounted() {
      this.refreshStatistics(this.form.tahun)
   },
   methods: {
      async refreshStatistics(year) {
         if (this.isRefreshing) return

         this.isRefreshing = true
         try {
            await this.getOss(year)
            this.triggerRefresh()
         } finally {
            this.isRefreshing = false
         }
      },
      formatStatistic(value) {
         return Number(value || 0).toLocaleString('id-ID')
      },
      ...mapActions({
         getOss: 'DashboardOss/getStatistik',
         triggerRefresh: 'DashboardOss/triggerRefresh',
      }),
   },
}
</script>

<template>
   <b-row>
      <b-col cols="12">
         <b-card no-body class="statistics-wrapper overflow-hidden">
            <div class="statistics-heading p-2 p-md-2 d-flex flex-wrap align-items-center justify-content-between">
               <div class="d-flex align-items-center">
                  <div class="logo-wrapper mr-1 mr-md-2">
                     <b-img
                        :src="require('@/assets/images/logo/oss.png')"
                        alt="Logo OSS RBA"
                        height="54"
                        class="img-fluid"
                     />
                  </div>
                  <div>
                     <h3 class="text-white mb-25">
                        OSS RBA
                     </h3>
                     <p class="text-white mb-0 statistics-subtitle">
                        Ringkasan statistik Online Single Submission berbasis risiko
                     </p>
                  </div>
               </div>
               <div class="oss-toolbar d-flex align-items-end mt-1 mt-md-0">
                  <b-form-group class="mb-0 mr-1">
                     <datepicker
                        id="dashboard-oss-tahun"
                        v-model="form.tahun"
                        :minimum-view="'year'"
                        :maximum-view="'year'"
                        format="yyyy"
                        input-class="datepicker-here form-control"
                        :disabled="isRefreshing"
                     />
                  </b-form-group>
                  <b-button
                     variant="light"
                     class="d-flex align-items-center"
                     :disabled="isRefreshing"
                     title="Muat ulang data"
                     @click="refreshStatistics(form.tahun)"
                  >
                     <b-spinner v-if="isRefreshing" small class="mr-50" />
                     <feather-icon v-else icon="RefreshCwIcon" class="mr-50" />
                     Refresh
                  </b-button>
               </div>
            </div>

            <b-card-body class="p-1 p-md-2">
               <b-row>
                  <b-col
                     v-for="group in statisticGroups"
                     :key="group.title"
                     cols="12"
                     md="6"
                     xl="3"
                     class="mb-1"
                  >
                     <b-card no-body class="stat-group h-100">
                        <div class="stat-group-header">
                           <div :class="['stat-group-icon', `icon-${group.color}`]">
                              <feather-icon :icon="group.icon" size="18" />
                           </div>
                           <h5 class="stat-group-title mb-0">
                              {{ group.title }}
                           </h5>
                        </div>
                        <b-card-body class="p-1">
                           <div
                              v-for="item in group.items"
                              :key="item.key"
                              class="stat-item"
                           >
                              <div class="stat-item-value">
                                 {{ formatStatistic(myData[item.key]) }}
                              </div>
                              <div class="stat-item-meta">
                                 <span class="stat-item-title">{{ item.title }}</span>
                                 <small class="text-muted">{{ item.description }}</small>
                              </div>
                           </div>
                        </b-card-body>
                     </b-card>
                  </b-col>
               </b-row>
            </b-card-body>
         </b-card>
      </b-col>
   </b-row>
</template>

<style scoped>
.statistics-wrapper {
   border: 0;
   border-radius: 12px;
   background-color: #ffffff;
   box-shadow: 0 4px 24px rgba(34, 41, 47, 0.08);
}

.statistics-heading {
   background: linear-gradient(135deg, #9f1e15 0%, #d94a3a 100%);
}

.logo-wrapper {
   width: 64px;
   height: 64px;
   display: flex;
   align-items: center;
   justify-content: center;
   padding: 5px;
   border-radius: 12px;
   background: rgba(255, 255, 255, 0.18);
}

.statistics-subtitle {
   opacity: 0.8;
   font-size: 0.85rem;
}

.stat-group {
   border: 1px solid #ebe9f1;
   border-radius: 12px;
   overflow: hidden;
   transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.stat-group:hover {
   transform: translateY(-3px);
   box-shadow: 0 8px 20px rgba(34, 41, 47, 0.1);
}

.stat-group-header {
   display: flex;
   align-items: center;
   gap: 0.6rem;
   padding: 0.85rem 1rem;
   border-bottom: 1px solid #ebe9f1;
   background: #fafbfc;
}

.stat-group-icon {
   width: 34px;
   height: 34px;
   display: flex;
   align-items: center;
   justify-content: center;
   flex-shrink: 0;
   border-radius: 9px;
}

.stat-group-title {
   color: #5e5873;
   font-size: 0.95rem;
   font-weight: 700;
   letter-spacing: 0.2px;
}

.stat-item {
   display: flex;
   align-items: center;
   gap: 0.75rem;
   padding: 0.6rem 0.25rem;
   border-bottom: 1px dashed #ebe9f1;
}

.stat-item:last-child {
   border-bottom: 0;
}

.stat-item-value {
   min-width: 56px;
   color: #5e5873;
   font-size: 1.3rem;
   font-weight: 700;
   line-height: 1;
   text-align: right;
}

.stat-item-meta {
   display: flex;
   flex-direction: column;
   min-width: 0;
}

.stat-item-title {
   color: #5e5873;
   font-size: 0.82rem;
   font-weight: 600;
   line-height: 1.2;
}

.stat-item-meta small {
   font-size: 0.7rem;
   line-height: 1.15;
}

.icon-primary { color: #7367f0; background: #eeedff; }
.icon-success { color: #28c76f; background: #e5f8ed; }
.icon-info { color: #00cfe8; background: #e0f9fc; }
.icon-warning { color: #ff9f43; background: #fff3e5; }
.icon-danger { color: #ea5455; background: #fce8e8; }

/* Dark layout overrides: keep card surfaces and text readable. */
.dark-layout .statistics-wrapper {
   background-color: #283046;
   box-shadow: 0 4px 24px rgba(0, 0, 0, 0.2);
}

.dark-layout .stat-group {
   border-color: #3b4253;
   background-color: #283046;
}

.dark-layout .stat-group-header {
   border-color: #3b4253;
   background-color: #242b3d;
}

.dark-layout .stat-group-title,
.dark-layout .stat-item-value,
.dark-layout .stat-item-title {
   color: #f6f6f6;
}

.dark-layout .stat-item {
   border-color: #3b4253;
}

.dark-layout .stat-item-meta .text-muted {
   color: #b4b7bd !important;
}

.dark-layout .icon-primary { background: rgba(115, 103, 240, 0.2); }
.dark-layout .icon-success { background: rgba(40, 199, 111, 0.2); }
.dark-layout .icon-info { background: rgba(0, 207, 232, 0.2); }
.dark-layout .icon-warning { background: rgba(255, 159, 67, 0.2); }
.dark-layout .icon-danger { background: rgba(234, 84, 85, 0.2); }

@media (max-width: 575.98px) {
   .statistics-heading { padding: 1rem !important; }
}
</style>
